export default "__VITE_ASSET__C2zCu2Ys__"